import { getLegacyPost } from './legacyPosts';

export default function LegacyArticleArt({ slug }: { slug: string }) {
  const post = getLegacyPost(slug);
  if (!post.editorial) return null;
  return (
    <img
      src={post.editorial}
      alt=""
      width="1440"
      height="480"
      decoding="async"
      className="not-prose mb-10 block aspect-[3/1] w-full rounded-xl bg-slate-950 object-cover"
    />
  );
}
